import React, { Component } from "react";
import {
  List,
  Edit,
  Datagrid,
  TextField,
  ReferenceField,
  Button,
  ReferenceInput,
  EditButton,
  TextInput,
  BooleanField,
  DateField,
  ImageField,
  BooleanInput,
  AutocompleteInput,
  SelectInput,
  required,
  SaveButton,
  SimpleForm,
  UrlField,
  Filter,
} from "react-admin";
import { Scrollbars } from "react-custom-scrollbars";
import Modal from "react-responsive-modal";
// import DateFnsUtils from '@date-io/date-fns';
// import MomentUtils from 'material-ui-pickers/utils/moment-utils';
// import mwLocale from "date-fns/locale/en_MW";
import myDataProvider from "../myRestProvider";

import noImage from "./../images/combined-shape.svg";
import moment from "moment";
import { CREATE } from "ra-core";
import { getLocalStorageKey } from "../common/common";

const StatusField = ({ record = {}, source }) => (
  <span>{record[source] === null ? "-" : record[source] ? "Yes" : "No"}</span>
);

const selectInputStyle = {
  width: 200,
};

const PostFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput source="purpose" defaultValue="" />
      <SelectInput
        source="status"
        choices={[
          { id: true, name: "True" },
          { id: false, name: "False" },
        ]}
        validate={required()}
        style={selectInputStyle}
      />
    </Filter>
  );
};

const styles = {
  image: {
    height: 50,
    width: 50,
  },
};

const EmailerBannerList = (props) => {
  return (
    <Scrollbars className="scroll-container">
      <List
        {...props}
        filters={<PostFilter />}
        sort={{ field: "created_at", order: "DESC" }}
        title="Emailer Banners"
        exporter={false}
      >
        <Datagrid bulkActionButtons={false}>
          <DateField
            source="created_at"
            label="Upload Timestamp"
            showTime
            sortable={false}
          />
          <TextField source="purpose" allowEmpty />
          <UrlField source="link" allowEmpty />
          <ImageField
            source="image_data"
            title="Uploaded Image"
            label="Uploaded Image"
          />
          <BooleanField source="status" />
          <EditButton label="Edit" />
        </Datagrid>
      </List>
    </Scrollbars>
  );
};

export default EmailerBannerList;
